<template>
 <div id="app">
  <div class="form__field">
   <div class="cell">
    <input @keyup.enter="queryResults" class="ids_topicSearch" id="ctl00_ids_contentPlaceHolder_ids_topicSearch" name="ctl00$ids_contentPlaceHolder$ids_topicSearch" placeholder="Search Contents" type="text" v-model="search"/>
   </div>
   <div class="search_button" v-if="search">
    <button @click="clearResult" class="close-icon">
     &times;
    </button>
   </div>
   <div class="search_button">
    <button @click="queryResults">
     <i class="fa fa-search">
     </i>
    </button>
   </div>
  </div>
  <div class="col-1 l-pad-top" id="results">
   <div>
    <p class="toc-2-style" style="margin-bottom: 10px;">
     <strong v-if="resultsCount != 0">
      ({{resultsCount}}) Results Found
     </strong>
     <strong v-else-if="resultsActual">
      No Results Found
     </strong>
    </p>
   </div>
   <div v-for="result of resultsActual">
    <p class="toc-2-style">
     <a :href="result.link" :keywords="result.keywords" onclick="reload(this.href, this.getAttribute('keywords'))">
      {{result.title}}
     </a>
    </p>
    <p class="toc-3-style">
     {{result.desc}}
    </p>
   </div>
  </div>
  <div class="side-toc" v-if="!resultsActual">
   <p class="toc-1-style">
    <a href="cover.html" title="MX931 MFP">
     MX931 MFP
    </a>
   </p>
   <p class="toc-1-style">
    <a href="safety.html#safety_pt" title="Informa&ccedil;&otilde;es sobre seguran&ccedil;a">
     Informa&ccedil;&otilde;es sobre seguran&ccedil;a
    </a>
   </p>
   <div id="divd0e18">
    <p class="toc-2-style">
     <a href=".html#d0e23" title="Conven&ccedil;&otilde;es">
      Conven&ccedil;&otilde;es
     </a>
    </p>
    <p class="toc-2-style">
     <a href="safety-cable-topic.html#d0e40" title="Declara&ccedil;&otilde;es de produtos">
      Declara&ccedil;&otilde;es de produtos
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="learn-about-printer-chapter.html#learn-about-printer-chapter_pt" title="Informa&ccedil;&otilde;es sobre a impressora">
     Informa&ccedil;&otilde;es sobre a impressora
    </a>
   </p>
   <div id="divd0e170">
    <p class="toc-2-style">
     <a href="finding-information-about-printer-topic.html#finding-information-about-printer_pt" title="Localizando informa&ccedil;&otilde;es sobre a impressora">
      Localizando informa&ccedil;&otilde;es sobre a impressora
     </a>
    </p>
    <p class="toc-2-style">
     <a href="finding-printer-serial-number-topic.html#finding-printer-serial-number_pt" title="Localiza&ccedil;&atilde;o do n&uacute;mero de s&eacute;rie da impressora">
      Localiza&ccedil;&atilde;o do n&uacute;mero de s&eacute;rie da impressora
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printer-configurations-topic.html#printer-configurations_pt" title="Configura&ccedil;&otilde;es da impressora">
      Configura&ccedil;&otilde;es da impressora
     </a>
    </p>
    <p class="toc-2-style">
     <a href="using-control-panel-topic.html#using-control-panel_pt" title="Uso do painel de controle">
      Uso do painel de controle
     </a>
    </p>
    <p class="toc-2-style">
     <a href="understanding-status-of-power-button-and-indicator-light-topic.html#understanding-status-of-power-button-and-indicator-light_pt" title="Compreendendo o status da luz indicadora">
      Compreendendo o status da luz indicadora
     </a>
    </p>
    <p class="toc-2-style">
     <a href="selecting-paper-group.html#d0e562" title="Como selecionar o papel">
      Como selecionar o papel
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="setup-install-and-configure-chapter.html#setup-install-and-configure-chapter_pt" title="Instala&ccedil;&atilde;o e configura&ccedil;&atilde;o">
     Instala&ccedil;&atilde;o e configura&ccedil;&atilde;o
    </a>
   </p>
   <div id="divd0e3841">
    <p class="toc-2-style">
     <a href="selecting-location-printer-topic.html#selecting-location-printer_pt" title="Sele&ccedil;&atilde;o de um local para a impressora">
      Sele&ccedil;&atilde;o de um local para a impressora
     </a>
    </p>
    <p class="toc-2-style">
     <a href="attaching-cables-topic.html#attaching-cables_pt" title="Conectando os cabos">
      Conectando os cabos
     </a>
    </p>
    <p class="toc-2-style">
     <a href="using-home-screen-topic.html#d0e4029" title="Configura&ccedil;&atilde;o e uso dos aplicativos da tela inicial">
      Configura&ccedil;&atilde;o e uso dos aplicativos da tela inicial
     </a>
    </p>
    <p class="toc-2-style">
     <a href="activating-voice-guidance-topic.html#d0e4646" title="Configura&ccedil;&atilde;o e uso dos recursos de acessibilidade">
      Configura&ccedil;&atilde;o e uso dos recursos de acessibilidade
     </a>
    </p>
    <p class="toc-2-style">
     <a href="setting-up-printer-to-fax-group.html#d0e4949" title="Configurando a impressora para enviar fax">
      Configurando a impressora para enviar fax
     </a>
    </p>
    <p class="toc-2-style">
     <a href="configuring-smtp-server-for-e-mail-topic.html#configuring-smtp-server-for-e-mail_pt" title="Como configurar o SMTP de e-mail">
      Como configurar o SMTP de e-mail
     </a>
    </p>
    <p class="toc-2-style">
     <a href="loading-trays-group.html#d0e6744" title="Carregamento de papel e m&iacute;dia especial">
      Carregamento de papel e m&iacute;dia especial
     </a>
    </p>
    <p class="toc-2-style">
     <a href="installing-printer-software-topic.html#d0e7137" title="Como instalar e atualizar software, drivers e firmware">
      Como instalar e atualizar software, drivers e firmware
     </a>
    </p>
    <p class="toc-2-style">
     <a href="installing-envelope-tray-topic.html#d0e7419" title="Instala&ccedil;&atilde;o de hardware opcional">
      Instala&ccedil;&atilde;o de hardware opcional
     </a>
    </p>
    <p class="toc-2-style">
     <a href="networking-intro-topic.html#d0e8091" title="Colocando em rede">
      Colocando em rede
     </a>
    </p>
    <p class="toc-2-style">
     <a href="setting-up-serial-printing-topic.html#setting-up-serial-printing_pt" title="Configura&ccedil;&atilde;o da impress&atilde;o serial (somente no Windows)">
      Configura&ccedil;&atilde;o da impress&atilde;o serial (somente no Windows)
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="securing-the-printer.html#securing-the-printer_pt" title="Prote&ccedil;&atilde;o da impressora">
     Prote&ccedil;&atilde;o da impressora
    </a>
   </p>
   <div id="divd0e8488">
    <p class="toc-2-style">
     <a href="locating-security-slot-topic.html#locating-security-slot_pt" title="Localiza&ccedil;&atilde;o do slot de seguran&ccedil;a">
      Localiza&ccedil;&atilde;o do slot de seguran&ccedil;a
     </a>
    </p>
    <p class="toc-2-style">
     <a href="erasing-printer-memory-topic.html#erasing-printer-memory_pt" title="Apagar a mem&oacute;ria da impressora">
      Apagar a mem&oacute;ria da impressora
     </a>
    </p>
    <p class="toc-2-style">
     <a href="erasing-printer-storage-drive-topic.html#erasing-printer-storage-drive_pt" title="Como apagar a unidade de armazenamento da impressora">
      Como apagar a unidade de armazenamento da impressora
     </a>
    </p>
    <p class="toc-2-style">
     <a href="restoring-factory-default-settings-topic.html#restoring-factory-default-settings_pt" title="Restaura&ccedil;&atilde;o das configura&ccedil;&otilde;es padr&atilde;o de f&aacute;brica">
      Restaura&ccedil;&atilde;o das configura&ccedil;&otilde;es padr&atilde;o de f&aacute;brica
     </a>
    </p>
    <p class="toc-2-style">
     <a href="statement-of-volatility-topic.html#statement-of-volatility_pt" title="Declara&ccedil;&atilde;o de volatilidade">
      Declara&ccedil;&atilde;o de volatilidade
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="print-chapter.html#print-chapter_pt" title="Print">
     Print
    </a>
   </p>
   <div id="divd0e8681">
    <p class="toc-2-style">
     <a href="printing-from-computer-h2-topic.html#printing-from-computer-h2_pt" title="Impress&atilde;o de um computador">
      Impress&atilde;o de um computador
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-from-mobile-device-using-lexmark-print-topic.html#d0e8707" title="Impress&atilde;o a partir de um dispositivo m&oacute;vel">
      Impress&atilde;o a partir de um dispositivo m&oacute;vel
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-from-flash-drive-topic.html#printing-from-flash-drive_pt" title="Impress&atilde;o a partir de uma unidade flash">
      Impress&atilde;o a partir de uma unidade flash
     </a>
    </p>
    <p class="toc-2-style">
     <a href="supported-flash-drives-and-file-types-topic.html#supported-flash-drives-and-file-types_pt" title="Unidades flash e tipos de arquivo suportados">
      Unidades flash e tipos de arquivo suportados
     </a>
    </p>
    <p class="toc-2-style">
     <a href="configuring-confidential-jobs-topic.html#configuring-confidential-jobs_pt" title="Configurar trabalhos confidenciais">
      Configurar trabalhos confidenciais
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-confidential-and-other-held-jobs-topic.html#printing-confidential-and-other-held-jobs_pt" title="Como imprimir trabalhos confidenciais e outros trabalhos suspensos">
      Como imprimir trabalhos confidenciais e outros trabalhos suspensos
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-font-sample-list-h2-topic.html#printing-font-sample-list-h2_pt" title="Imprimindo uma lista de amostras de fontes">
      Imprimindo uma lista de amostras de fontes
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-directory-list-h2-topic.html#printing-directory-list-h2_pt" title="Impress&atilde;o de uma lista de diret&oacute;rios">
      Impress&atilde;o de uma lista de diret&oacute;rios
     </a>
    </p>
    <p class="toc-2-style">
     <a href="placing-separator-sheets-topic.html#placing-separator-sheets_pt" title="Folhas separadoras entre as c&oacute;pias">
      Folhas separadoras entre as c&oacute;pias
     </a>
    </p>
    <p class="toc-2-style">
     <a href="stapling-printed-sheets-topic.html#stapling-printed-sheets_pt" title="Grampeamento de folhas impressas">
      Grampeamento de folhas impressas
     </a>
    </p>
    <p class="toc-2-style">
     <a href="punching-holes-printed-sheets-topic.html#punching-holes-printed-sheets_pt" title="Perfura&ccedil;&atilde;o em folhas impressas">
      Perfura&ccedil;&atilde;o em folhas impressas
     </a>
    </p>
    <p class="toc-2-style">
     <a href="using-offset-stacking-printed-sheets-topic.html#using-offset-stacking-printed-sheets_pt" title="Como usar o empilhamento de separa&ccedil;&atilde;o em folhas impressas">
      Como usar o empilhamento de separa&ccedil;&atilde;o em folhas impressas
     </a>
    </p>
    <p class="toc-2-style">
     <a href="canceling-print-job-topic.html#canceling-print-job_pt" title="Cancelamento de um trabalho de impress&atilde;o">
      Cancelamento de um trabalho de impress&atilde;o
     </a>
    </p>
    <p class="toc-2-style">
     <a href="adjusting-toner-darkness-topic.html#adjusting-toner-darkness_pt" title="Ajustando a tonalidade do toner">
      Ajustando a tonalidade do toner
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="copying-chapter.html#copying-chapter_pt" title="Copiar">
     Copiar
    </a>
   </p>
   <div id="divd0e9472">
    <p class="toc-2-style">
     <a href="using-ADF-and-scanner-glass-copy-topic.html#using-ADF-and-scanner-glass-copy_pt" title="Usando o alimentador autom&aacute;tico de documentos e o vidro do scanner">
      Usando o alimentador autom&aacute;tico de documentos e o vidro do scanner
     </a>
    </p>
    <p class="toc-2-style">
     <a href="making-copies-topic.html#making-copies_pt" title="C&oacute;pias">
      C&oacute;pias
     </a>
    </p>
    <p class="toc-2-style">
     <a href="copying-photos-topic.html#copying-photos_pt" title="C&oacute;pia de fotos">
      C&oacute;pia de fotos
     </a>
    </p>
    <p class="toc-2-style">
     <a href="copying-transparencies-or-letterhead-topic.html#copying-transparencies-or-letterhead_pt" title="Copiando em papel timbrado">
      Copiando em papel timbrado
     </a>
    </p>
    <p class="toc-2-style">
     <a href="copying-on-both-sides-of-paper-topic.html#copying-on-both-sides-of-paper_pt" title="C&oacute;pia nos dois lados do papel">
      C&oacute;pia nos dois lados do papel
     </a>
    </p>
    <p class="toc-2-style">
     <a href="reducing-enlarging-copies-topic.html#reducing-enlarging-copies_pt" title="Redu&ccedil;&atilde;o ou amplia&ccedil;&atilde;o de c&oacute;pias">
      Redu&ccedil;&atilde;o ou amplia&ccedil;&atilde;o de c&oacute;pias
     </a>
    </p>
    <p class="toc-2-style">
     <a href="collating-copies-topic.html#collating-copies_pt" title="Agrupamento de c&oacute;pias">
      Agrupamento de c&oacute;pias
     </a>
    </p>
    <p class="toc-2-style">
     <a href="placing-separator-sheets-between-copies-topic.html#placing-separator-sheets-between-copies_pt" title="Folhas separadoras entre as c&oacute;pias">
      Folhas separadoras entre as c&oacute;pias
     </a>
    </p>
    <p class="toc-2-style">
     <a href="saving-paper-topic.html#saving-paper_pt" title="Para copiar v&aacute;rias p&aacute;ginas em uma &uacute;nica folha">
      Para copiar v&aacute;rias p&aacute;ginas em uma &uacute;nica folha
     </a>
    </p>
    <p class="toc-2-style">
     <a href="copying-cards-topic.html#copying-cards_pt" title="C&oacute;pia de cart&otilde;es">
      C&oacute;pia de cart&otilde;es
     </a>
    </p>
    <p class="toc-2-style">
     <a href="stapling-copies-topic.html#stapling-copies_pt" title="Grampeamento de c&oacute;pias">
      Grampeamento de c&oacute;pias
     </a>
    </p>
    <p class="toc-2-style">
     <a href="punching-holes-copies-topic.html#punching-holes-copies_pt" title="Perfura&ccedil;&atilde;o em c&oacute;pias">
      Perfura&ccedil;&atilde;o em c&oacute;pias
     </a>
    </p>
    <p class="toc-2-style">
     <a href="using-offset-stacking-copies-topic.html#using-offset-stacking-copies_pt" title="Usando empilhamento de separa&ccedil;&atilde;o em c&oacute;pias">
      Usando empilhamento de separa&ccedil;&atilde;o em c&oacute;pias
     </a>
    </p>
    <p class="toc-2-style">
     <a href="creating-copy-shortcut-topic.html#creating-copy-shortcut_pt" title="Criando um atalho de c&oacute;pia">
      Criando um atalho de c&oacute;pia
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="e-mailing-chapter.html#e-mailing-chapter_pt" title="E-mail">
     E-mail
    </a>
   </p>
   <div id="divd0e9851">
    <p class="toc-2-style">
     <a href="using-ADF-and-scanner-glass-e-mail-topic.html#using-ADF-and-scanner-glass-e-mail_pt" title="Usando o alimentador autom&aacute;tico de documentos e o vidro do scanner">
      Usando o alimentador autom&aacute;tico de documentos e o vidro do scanner
     </a>
    </p>
    <p class="toc-2-style">
     <a href="sending-email-topic.html#sending-email_pt" title="Como enviar e- mail">
      Como enviar e- mail
     </a>
    </p>
    <p class="toc-2-style">
     <a href="creating-email-shortcut-topic.html#creating-email-shortcut-using-control-panel_pt" title="Cria&ccedil;&atilde;o de um atalho de e-mail">
      Cria&ccedil;&atilde;o de um atalho de e-mail
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="faxing-chapter.html#faxing-chapter_pt" title="Fax">
     Fax
    </a>
   </p>
   <div id="divd0e9945">
    <p class="toc-2-style">
     <a href="using-ADF-and-scanner-glass-fax-topic.html#using-ADF-and-scanner-glass-fax_pt" title="Usando o alimentador autom&aacute;tico de documentos e o vidro do scanner">
      Usando o alimentador autom&aacute;tico de documentos e o vidro do scanner
     </a>
    </p>
    <p class="toc-2-style">
     <a href="sending-fax-topic.html#sending-fax_pt" title="Como enviar um fax">
      Como enviar um fax
     </a>
    </p>
    <p class="toc-2-style">
     <a href="scheduling-fax-topic.html#scheduling-fax_pt" title="Programa&ccedil;&atilde;o do envio de um fax">
      Programa&ccedil;&atilde;o do envio de um fax
     </a>
    </p>
    <p class="toc-2-style">
     <a href="creating-fax-destination-shortcut-topic.html#creating-fax-destination-shortcut_pt" title="Criando um atalho de destino de fax">
      Criando um atalho de destino de fax
     </a>
    </p>
    <p class="toc-2-style">
     <a href="changing-fax-resolution-topic.html#changing-fax-resolution_pt" title="Como alterar a resolu&ccedil;&atilde;o do fax">
      Como alterar a resolu&ccedil;&atilde;o do fax
     </a>
    </p>
    <p class="toc-2-style">
     <a href="adjusting-fax-darkness-topic.html#adjusting-fax-darkness_pt" title="Como ajustar a tonalidade do fax">
      Como ajustar a tonalidade do fax
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-fax-log-topic.html#printing-fax-log_pt" title="Impress&atilde;o de um log de fax">
      Impress&atilde;o de um log de fax
     </a>
    </p>
    <p class="toc-2-style">
     <a href="blocking-junk-faxes-topic.html#blocking-junk-faxes_pt" title="Como bloquear faxes indesejados">
      Como bloquear faxes indesejados
     </a>
    </p>
    <p class="toc-2-style">
     <a href="holding-faxes-topic.html#holding-faxes_pt" title="Como reter fax">
      Como reter fax
     </a>
    </p>
    <p class="toc-2-style">
     <a href="forwarding-fax-topic.html#forwarding-fax_pt" title="Como encaminhar fax">
      Como encaminhar fax
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="ftp-chapter.html#ftp-chapter_pt" title="Examinar">
     Examinar
    </a>
   </p>
   <div id="divd0e10309">
    <p class="toc-2-style">
     <a href="using-ADF-and-scanner-glass-scan-topic.html#using-ADF-and-scanner-glass-scan_pt" title="Usando o alimentador autom&aacute;tico de documentos e o vidro do scanner">
      Usando o alimentador autom&aacute;tico de documentos e o vidro do scanner
     </a>
    </p>
    <p class="toc-2-style">
     <a href="scanning-to-computer-topic.html#scanning-to-computer_pt" title="Digitaliza&ccedil;&atilde;o para um computador">
      Digitaliza&ccedil;&atilde;o para um computador
     </a>
    </p>
    <p class="toc-2-style">
     <a href="scanning-ftp-server-using-control-panel-topic.html#scanning-ftp-server-using-control-panel_pt" title="Digitaliza&ccedil;&atilde;o para um servidor FTP">
      Digitaliza&ccedil;&atilde;o para um servidor FTP
     </a>
    </p>
    <p class="toc-2-style">
     <a href="creating-FTP-shortcut-topic.html#creating-FTP-shortcut_pt" title="Cria&ccedil;&atilde;o de um atalho de FTP">
      Cria&ccedil;&atilde;o de um atalho de FTP
     </a>
    </p>
    <p class="toc-2-style">
     <a href="s2a-scanning-to-network-folders-topic.html#s2a-scanning-to-network-folders_pt" title="Digitaliza&ccedil;&atilde;o em uma pasta de rede">
      Digitaliza&ccedil;&atilde;o em uma pasta de rede
     </a>
    </p>
    <p class="toc-2-style">
     <a href="creating-network-folder-shortcut-topic.html#creating-network-folder-shortcut_pt" title="Criando um atalho para a pasta da rede">
      Criando um atalho para a pasta da rede
     </a>
    </p>
    <p class="toc-2-style">
     <a href="scanning-to-flash-drive-topic.html#scanning-to-flash-drive_pt" title="Como digitalizar para uma unidade flash">
      Como digitalizar para uma unidade flash
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="use-printer-menus-chapter.html#use-printer-menus-chapter_pt" title="Uso dos menus da impressora">
     Uso dos menus da impressora
    </a>
   </p>
   <div id="divd0e10612">
    <p class="toc-2-style">
     <a href="menu-map-mfp-topic.html#menus-map-mfp_pt" title="Mapa de menus">
      Mapa de menus
     </a>
    </p>
    <p class="toc-2-style">
     <a href="preferences-topic.html#d0e10975" title="Dispositivo">
      Dispositivo
     </a>
    </p>
    <p class="toc-2-style">
     <a href="layout-topic.html#d0e13263" title="Print">
      Print
     </a>
    </p>
    <p class="toc-2-style">
     <a href="tray-configuration-topic.html#d0e14531" title="Papel">
      Papel
     </a>
    </p>
    <p class="toc-2-style">
     <a href="copy-defaults-topic.html#d0e14900" title="Copiar">
      Copiar
     </a>
    </p>
    <p class="toc-2-style">
     <a href="fax-defaults-subgroup.html#d0e15489" title="Fax">
      Fax
     </a>
    </p>
    <p class="toc-2-style">
     <a href="email-setup-topic.html#d0e17895" title="E-mail">
      E-mail
     </a>
    </p>
    <p class="toc-2-style">
     <a href="ftp-defaults-topic.html#d0e18945" title="FTP">
      FTP
     </a>
    </p>
    <p class="toc-2-style">
     <a href="flash-drive-scan-topic.html#d0e19623" title="Unidade USB">
      Unidade USB
     </a>
    </p>
    <p class="toc-2-style">
     <a href="network-overview-topic.html#d0e20468" title="Rede/portas">
      Rede/portas
     </a>
    </p>
    <p class="toc-2-style">
     <a href="cloud-services-enrollment-topic.html#d0e22659" title="Servi&ccedil;os na nuvem">
      Servi&ccedil;os na nuvem
     </a>
    </p>
    <p class="toc-2-style">
     <a href="login-methods-subgroup.html#d0e22716" title="Seguran&ccedil;a">
      Seguran&ccedil;a
     </a>
    </p>
    <p class="toc-2-style">
     <a href="menu-settings-page-topic.html#d0e23905" title="Relat&oacute;rios">
      Relat&oacute;rios
     </a>
    </p>
    <p class="toc-2-style">
     <a href="troubleshooting-menu-topic.html#troubleshooting-menu_pt" title="Solu&ccedil;&atilde;o de problemas">
      Solu&ccedil;&atilde;o de problemas
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-menu-settings-page-topic.html#printing-menu-settings-page_pt" title="Impress&atilde;o da P&aacute;gina de defini&ccedil;&otilde;es de menu">
      Impress&atilde;o da P&aacute;gina de defini&ccedil;&otilde;es de menu
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="maintain-printer-chapter.html#maintain-printer-chapter_pt" title="Manuten&ccedil;&atilde;o da impressora">
     Manuten&ccedil;&atilde;o da impressora
    </a>
   </p>
   <div id="divd0e24245">
    <p class="toc-2-style">
     <a href="checking-status-of-parts-and-supplies-topic.html#checking-status-of-parts-and-supplies_pt" title="Verifica&ccedil;&atilde;o do status de pe&ccedil;as e suprimentos">
      Verifica&ccedil;&atilde;o do status de pe&ccedil;as e suprimentos
     </a>
    </p>
    <p class="toc-2-style">
     <a href="configuring-supply-notifications-topic.html#configuring-supply-notifications_pt" title="Configura&ccedil;&atilde;o de notifica&ccedil;&otilde;es de suprimento">
      Configura&ccedil;&atilde;o de notifica&ccedil;&otilde;es de suprimento
     </a>
    </p>
    <p class="toc-2-style">
     <a href="setting-up-e-mail-alert-topic.html#setting-up-e-mail-alert_pt" title="Configurando os alertas de e-mail">
      Configurando os alertas de e-mail
     </a>
    </p>
    <p class="toc-2-style">
     <a href="viewing-reports-topic.html#viewing-reports_pt" title="Exibindo relat&oacute;rios">
      Exibindo relat&oacute;rios
     </a>
    </p>
    <p class="toc-2-style">
     <a href="ordering-parts-and-supplies-group.html#ordering-supplies-group_pt" title="Solicita&ccedil;&atilde;o de pe&ccedil;as e suprimentos">
      Solicita&ccedil;&atilde;o de pe&ccedil;as e suprimentos
     </a>
    </p>
    <p class="toc-2-style">
     <a href="replacing-toner-cartridge-topic.html#d0e24446" title="Troca de pe&ccedil;as e suprimentos">
      Troca de pe&ccedil;as e suprimentos
     </a>
    </p>
    <p class="toc-2-style">
     <a href="cleaning-printer-topic.html#d0e24991" title="Como limpar pe&ccedil;as da impressora">
      Como limpar pe&ccedil;as da impressora
     </a>
    </p>
    <p class="toc-2-style">
     <a href="configuring-power-save-mode-settings-topic.html#d0e25244" title="Como economizar energia e papel">
      Como economizar energia e papel
     </a>
    </p>
    <p class="toc-2-style">
     <a href="moving-printer-topic.html#moving-printer_pt" title="Para mover a impressora para outro local">
      Para mover a impressora para outro local
     </a>
    </p>
    <p class="toc-2-style">
     <a href="shipping-printer-topic.html#shipping-printer_pt" title="Transporte da impressora">
      Transporte da impressora
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="troubleshoot-problem-chapter.html#troubleshoot-problem-chapter_pt" title="Solu&ccedil;&atilde;o de problemas">
     Solu&ccedil;&atilde;o de problemas
    </a>
   </p>
   <div id="divd0e25398">
    <p class="toc-2-style">
     <a href="print-quality-problems-picker-topic.html#print-quality-problems-picker_pt" title="Problemas de qualidade de impress&atilde;o">
      Problemas de qualidade de impress&atilde;o
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printer-error-codes-topic.html#printer-error-codes_pt" title="C&oacute;digos de erro da impressora">
      C&oacute;digos de erro da impressora
     </a>
    </p>
    <p class="toc-2-style">
     <a href="print-quality-is-poor-subgroup.html#d0e26352" title="Problemas de impress&atilde;o">
      Problemas de impress&atilde;o
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-printer-not-responding-topic.html#trb-printer-not-responding_pt" title="A impressora n&atilde;o est&aacute; respondendo">
      A impressora n&atilde;o est&aacute; respondendo
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-unable-to-read-flash-drive-topic.html#trb-unable-to-read-flash-drive_pt" title="N&atilde;o foi poss&iacute;vel ler unidade flash">
      N&atilde;o foi poss&iacute;vel ler unidade flash
     </a>
    </p>
    <p class="toc-2-style">
     <a href="enabling-usb-port-topic.html#enabling-usb-port_pt" title="Ativando a porta USB">
      Ativando a porta USB
     </a>
    </p>
    <p class="toc-2-style">
     <a href="avoiding-jams-topic.html#d0e28917" title="Limpeza de atolamentos">
      Limpeza de atolamentos
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-cannot-open-embedded-web-server-topic.html#d0e29427" title="Problemas de conex&atilde;o de rede">
      Problemas de conex&atilde;o de rede
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-cannot-detect-internal-option-topic.html#d0e29655" title="Problemas de op&ccedil;&otilde;es de hardware">
      Problemas de op&ccedil;&otilde;es de hardware
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-missing-or-unresponsive-toner-cartridge-topic.html#d0e29781" title="Problemas com suprimentos">
      Problemas com suprimentos
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-envelope-seals-when-printing-topic.html#d0e29886" title="Problemas na bandeja de papel">
      Problemas na bandeja de papel
     </a>
    </p>
    <p class="toc-2-style">
     <a href="disabling-smtp-server-not-setup-error-topic.html#d0e30252" title="Problemas de envio de e-mail">
      Problemas de envio de e-mail
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-caller-id-not-shown-topic.html#d0e30346" title="Problemas de envio de fax">
      Problemas de envio de fax
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-cannot-scan-to-computer-topic.html#d0e30991" title="Problemas de digitaliza&ccedil;&atilde;o">
      Problemas de digitaliza&ccedil;&atilde;o
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-contacting-customer-support-topic.html#trb-contacting-customer-support_pt" title="Entrando em contato com o suporte ao cliente">
      Entrando em contato com o suporte ao cliente
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="recycle-dispose-chapter.html#recycle-dispose-chapter_pt" title="Reciclagem e descarte">
     Reciclagem e descarte
    </a>
   </p>
   <div id="divd0e31787">
    <p class="toc-2-style">
     <a href="recycling-lexmark-products-topic.html#recycling-lexmark-products_pt" title="Reciclagem de produtos da Lexmark">
      Reciclagem de produtos da Lexmark
     </a>
    </p>
    <p class="toc-2-style">
     <a href="recycling-lexmark-packaging-topic.html#recycling-lexmark-packaging_pt" title="Reciclagem de embalagens da Lexmark">
      Reciclagem de embalagens da Lexmark
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="laser_ug_notices.html#laser_ug_notices_pt" title="Avisos">
     Avisos
    </a>
   </p>
   <div id="divd0e31822">
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e31825" title="Informa&ccedil;&otilde;es sobre o produto">
      Informa&ccedil;&otilde;es sobre o produto
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e31842" title="Aviso de edi&ccedil;&atilde;o">
      Aviso de edi&ccedil;&atilde;o
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#trademarks_pt" title="Marcas comerciais">
      Marcas comerciais
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#licensing-notices_pt" title="Avisos de licenciamento">
      Avisos de licenciamento
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#noise-emission-levels_pt" title="N&iacute;veis de emiss&atilde;o de ru&iacute;do">
      N&iacute;veis de emiss&atilde;o de ru&iacute;do
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#weee-directive_pt" title="Diretiva de res&iacute;duos de equipamentos el&eacute;tricos e eletr&ocirc;nicos (WEEE, Waste from Electrical and Electronic Equipment)">
      Diretiva de res&iacute;duos de equipamentos el&eacute;tricos e eletr&ocirc;nicos (WEEE, Waste from Electrical and Electronic Equipment)
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e31947" title="Bateria recarreg&aacute;vel de &iacute;ons de l&iacute;tio">
      Bateria recarreg&aacute;vel de &iacute;ons de l&iacute;tio
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#product-disposal_pt" title="Descarte do produto">
      Descarte do produto
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#returning-lexmark-cartridges-for-reuse-or-recycling_pt" title="A devolu&ccedil;&atilde;o de cartuchos Lexmark para reutiliza&ccedil;&atilde;o ou reciclagem">
      A devolu&ccedil;&atilde;o de cartuchos Lexmark para reutiliza&ccedil;&atilde;o ou reciclagem
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#static-sensitivity-notice_pt" title="Aviso de sensibilidade &agrave; est&aacute;tica">
      Aviso de sensibilidade &agrave; est&aacute;tica
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#energy-star_pt" title="ENERGY STAR">
      ENERGY STAR
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#temperature-information_pt" title="Informa&ccedil;&otilde;es sobre temperatura">
      Informa&ccedil;&otilde;es sobre temperatura
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#power-consumption_pt" title="Consumo de energia">
      Consumo de energia
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#notice-to-users-of-products-in-brazil_pt" title="Aviso aos usu&aacute;rios de produtos no Brasil">
      Aviso aos usu&aacute;rios de produtos no Brasil
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#regulatory-notices-for-telecommunication-terminal-equipment_pt" title="Avisos regulamentares para equipamentos de terminal de telecomunica&ccedil;&atilde;o">
      Avisos regulamentares para equipamentos de terminal de telecomunica&ccedil;&atilde;o
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#notice-to-users-of-class-a-products-in-brazil_pt" title="Aviso aos usu&aacute;rios de produtos de Classe A no Brasil">
      Aviso aos usu&aacute;rios de produtos de Classe A no Brasil
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#european-community-ec-directives-conformity-class-a_pt" title="Conformidade com as diretivas da Comunidade Europeia (CE)">
      Conformidade com as diretivas da Comunidade Europeia (CE)
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#radio-interference-notice_pt" title="Aviso de radiointerfer&ecirc;ncia">
      Aviso de radiointerfer&ecirc;ncia
     </a>
    </p>
   </div>
  </div>
 </div>
</template>
<script>
 import output from './output.json';

const fuzzysort = require('fuzzysort');
const lunr = require("lunr")
require("lunr-languages/lunr.stemmer.support.js")(lunr)
require('lunr-languages/lunr.multi')(lunr)
require("lunr-languages/tinyseg.js")(lunr)
require("lunr-languages/lunr.de.js")(lunr)
require("lunr-languages/lunr.es.js")(lunr)
require("lunr-languages/lunr.fr.js")(lunr)
require("lunr-languages/lunr.it.js")(lunr)
require("lunr-languages/lunr.ja.js")(lunr)
require("lunr-languages/lunr.pt.js")(lunr)

export default {
  name: 'app',
  data() {
    return {
        search: '',
        resultsActual: '',
        list: output,
        resultsCount: 0,
    }
  },

  methods: { queryResults() {

      if (this.search.trim() === ''){
        return  '';
      }
    //   else if(this.search.trim().length < 3){
    //     this.resultsActual = new Array();
    //     this.resultsCount = 0;
    //   }
      else {
        var documents = this.list;

        var idx = lunr(function () {
            this.use(lunr.ja);
            this.use(lunr.multiLanguage('en', 'de', 'es', 'fr', 'it', 'ja', 'pt'))
            this.ref('UUID');
            this.field('title');
            this.field('descFull');
            this.metadataWhitelist = ['position'];

            documents.forEach(function (doc) {
                        this.add(doc)
                    },this);
            });
        

        var searchTerms = this.search.replace(/[`~!#$%^&*()|+\-=?;:'",.<>\{\}\[\]\\/]/gi, ' ').trim().replace(/\s\s+/g, " ");
        // var searchTerms = this.search;
        searchTerms = this.removeStopWords(searchTerms);
        var searchRawTerms = searchTerms;
        // searchTerms  =  searchTerms.split(" ").join(" +");
        // searchTerms = searchTerms.startsWith(" +") ? searchTerms : "+" + searchTerms;

        console.log(searchTerms);
        var results = idx.search(searchTerms);

        console.log (results);

        results = results.map(res => {
            var linkRes =  documents.find(elem => elem.UUID == res.ref);
            var keywords_array = new Array();
            var keywords_arrays = new Array();
            var keywords_arrays_title = new Array();

            Object.keys(res.matchData.metadata).map(kys => {
                var positions_title = res.matchData.metadata[kys].title;
                var positions_desc = res.matchData.metadata[kys].descFull;

                if(typeof positions_title !== 'undefined' ){
                    positions_title.position.forEach(function(val, i, arr){
                        keywords_array.push(linkRes.descFull.substring(val[0],val[0] + val[1]));
                        keywords_arrays_title.push(val[0],val[1]);
                    });
                }

                if(typeof positions_desc !== 'undefined' ){
                    positions_desc.position.forEach(function(val, i, arr){
                        keywords_array.push(linkRes.descFull.substring(val[0],val[0] + val[1]));
                        keywords_arrays.push(val[0],val[1]);
                    });
                }
            });

            

            res.link = linkRes.link;
            res.desc = linkRes.desc;
            res.title = linkRes.title;
            res.full = linkRes.descFull;
            res.titleArray = keywords_arrays_title;
            res.descArray = keywords_arrays;
            keywords_array = keywords_array.filter(function(item, index){ 
                return searchRawTerms.indexOf(item) >= 0;
            });
            var keywords_set = new Set(keywords_array);
            res.keywords = [...keywords_set].toString();
            // res.keywords = ["ramon","joe","gudz"]
            return res;
        });
        
        var existingPagesInResult = new Array();
        

       
        results = results.filter(function(item, index){
                
            if(existingPagesInResult.includes(item.link)){
                
                return false;
            }
            else { 
                existingPagesInResult.push(item.link);
                return true;
            }

            if(res.keywords == ""){
                return false;
            }
        });

        

        console.log (results);
        this.resultsActual = results;
        this.resultsCount = results.length;
      }
    },

    clearResult: function(){
        this.search = "";
        this.resultsActual = undefined;
        this.resultsCount = 0;
        reload("cover.html", "");
       
    },  

    removeStopWords: function(queryString) {
        const stopWords = ['i', 'me', 'my', 'myself', 'we', 'our', 'ours', 'ourselves', 'you', "you're", "you've", "you'll", "you'd", 'your', 'yours', 'yourself', 'yourselves', 
        'he', 'him', 'his', 'himself', 'she', "she's", 'her', 'hers', 'herself', 'it', "it's", 'its', 'itself', 'they', 'them', 'their', 'theirs', 'themselves', 'what', 'which', 
        'who', 'whom', 'this', 'that', "that'll", 'these', 'those', 'am', 'is', 'are', 'was', 'were', 'be', 'been', 'being', 'have', 'has', 'had', 'having', 'do', 'does', 'did', 
        'doing', 'a', 'an', 'the', 'and', 'but', 'if', 'or', 'because', 'as', 'until', 'while', 'of', 'at', 'by', 'for', 'with', 'about', 'against', 'between', 'into', 'through', 
        'during', 'before', 'after', 'above', 'below', 'to', 'from', 'up', 'down', 'in', 'out', 'on', 'off', 'over', 'under', 'again', 'further', 'then', 'once', 'here', 'there', 
        'when', 'where', 'why', 'how', 'all', 'any', 'both', 'each', 'few', 'more', 'most', 'other', 'some', 'such', 'no', 'nor', 'not', 'only', 'own', 'same', 'so', 'than', 'too', 
        'very', 's', 't', 'can', 'will', 'just', 'don', "don't", 'should', "should've", 'now', 'd', 'll', 'm', 'o', 're', 've', 'y', 'ain', 'aren', "aren't", 'couldn', "couldn't", 
        'didn', "didn't", 'doesn', "doesn't", 'hadn', "hadn't", 'hasn', "hasn't", 'haven', "haven't", 'isn', "isn't", 'ma', 'mightn', "mightn't", 'mustn', "mustn't", 'needn', 
         "needn't", 'shan', "shan't", 'shouldn', "shouldn't", 'wasn', "wasn't", 'weren', "weren't", 'won', "won't", 'wouldn', "wouldn't"]

        var cleanQueryString = new Array();
        queryString.split(" ").forEach(word => {
             if(!stopWords.includes(word)) {
                 cleanQueryString.push(word);
             }
        });

        return cleanQueryString.join(" ");
    },
    
  }
}
</script>


// WEBPACK FOOTER //
// src/App.vue